<template>
<div class="chapter">
<div class="inner_page">
<p class="center" id="dedication"><span><i>For my godsons, Jason and Ethan Lazar, who serve as constant reminders that family comes in all shapes and forms.</i></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 3dedication.vue?627d525b